import { generateId, TIPTAP_IMAGE_TYPE } from 'ricos-content';
import imageDataDefaults from 'ricos-schema/dist/statics/image.defaults.json';
import { createRicosNodeExtension, Uploader } from 'wix-rich-content-plugin-commons';
import { ImagePluginService } from '../toolbar/imagePluginService.js';
import { EditorImage } from './component.js';
import 'lodash';
import 'react';
import 'ricos-context';
import 'ricos-schema';
import 'wix-rich-content-ui-components';
import '../viewer/get-image-click-action-config.js';
import '../viewer/image.js';
import 'classnames';
import '../image-viewer.rtlignore-122fd826.js';
import '../style-inject.es-e7b07dd7.js';
import '../consts.js';
import '../icons/expand.js';
import '../viewer/image-container.js';
import '../dataHooks.js';
import '../viewer/use-custom-width-style.js';
import '../viewer/use-fallback-width-style.js';
import '../viewer/use-image-dimensions.js';
import '../viewer/use-image-social-attributes.js';
import './editor-image-caption.js';
import '../InPluginInput.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const name = TIPTAP_IMAGE_TYPE;
const tiptapExtensions = [
  createRicosNodeExtension({
    type: "react-node",
    name,
    groups: ["spoilerable", "resizable", "draggable", "not-overtypable"],
    reconfigure: (config, _extensions, _props, settings, services) => __spreadProps(__spreadValues({}, config), {
      addOptions: () => __spreadValues({
        services,
        imagePluginService: new ImagePluginService()
      }, settings)
    }),
    Component: EditorImage,
    createExtensionConfig({ Plugin, PluginKey }) {
      return {
        name: this.name,
        atom: false,
        group: "block",
        selectable: true,
        draggable: true,
        addAttributes: () => __spreadProps(__spreadValues({}, imageDataDefaults), {
          loading: {
            default: false
          },
          loadingPercentage: {
            default: null
          },
          tempData: {
            default: null
          }
        }),
        addProseMirrorPlugins() {
          return [
            new Plugin({
              key: new PluginKey("handlePasteImage"),
              props: {
                handlePaste: (_, event) => {
                  var _a, _b;
                  let hasFiles = false;
                  if ((_a = event == null ? void 0 : event.clipboardData) == null ? void 0 : _a.types.includes("text/plain")) {
                    return false;
                  }
                  Array.from(((_b = event == null ? void 0 : event.clipboardData) == null ? void 0 : _b.files) || []).filter((file) => file.type.startsWith("image")).forEach((file) => {
                    var _a2, _b2;
                    const nodeId = generateId();
                    this.editor.commands.insertContent({
                      type: TIPTAP_IMAGE_TYPE,
                      attrs: __spreadValues({ id: nodeId }, imageDataDefaults)
                    });
                    (_b2 = (_a2 = this.options.services) == null ? void 0 : _a2.uploadService) == null ? void 0 : _b2.uploadFile(
                      file,
                      nodeId,
                      new Uploader(this.options.handleFileUpload),
                      TIPTAP_IMAGE_TYPE,
                      this.options.imagePluginService
                    );
                    hasFiles = true;
                  });
                  if (hasFiles) {
                    event.preventDefault();
                    return true;
                  }
                  return false;
                }
              }
            })
          ];
        },
        addCommands() {
          return {
            setImageUrl: (url) => ({ commands }) => {
              return commands.updateAttributes(name, { image: { src: { custom: url } } });
            },
            setImageLoading: (loading) => ({ commands }) => {
              return commands.updateAttributes(name, { loading });
            }
          };
        }
      };
    }
  })
];

export { tiptapExtensions };
//# sourceMappingURL=tiptap.js.map
